import { Card, Col, Divider, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../../shared/components/buttons/custom-button/custom-button';
import { useAppDispatch } from '../../../../store/hooks';
import { openModal } from '../../../ui/store/ui-slice';
import { useGetUserQuery } from '../../api/user-api';
import { currentUserPasswordModalId, totpModalDisableId, totpModalEnableId } from '../../constants/constants';
import { setActiveCurrentUserId } from '../../store/current-user-slice';
import DisableTotpModal from '../disable-totp-modal/disable-topt-modal';
import EnableTotpModal from '../enable-totp-modal/enable-totp-modal';
import styles from './current-user-password-totp-card.module.css';

const CurrentUserPasswordTotpCard = (): JSX.Element => {
  const { data: currentUser } = useGetUserQuery();
  const dispatch = useAppDispatch();
  const { t } = useTranslation('current-user');

  const handleOpenPasswordEditModal = () => {
    if (currentUser?.id && currentUser?.canChangePassword) {
      dispatch(openModal(currentUserPasswordModalId));
      dispatch(setActiveCurrentUserId(currentUser?.id));
    }
  };

  const handleOpenTotpModal = (modalId: string) => dispatch(openModal(modalId));

  return (
    <Card title={t('userInfo.accountInfo')} className={styles.card}>
      <Row justify="space-between">
        <Col>{t('totp.totpLabel')}</Col>
        <Col>
          {!currentUser?.totpEnabled ? (
            <CustomButton onClick={() => handleOpenTotpModal(totpModalEnableId)}>{t('totp.totpEnable')}</CustomButton>
          ) : (
            <CustomButton onClick={() => handleOpenTotpModal(totpModalDisableId)} type="secondary">
              {t('totp.totpDisable')}
            </CustomButton>
          )}
        </Col>
        <Divider />
      </Row>
      <CustomButton onClick={() => handleOpenPasswordEditModal()} disabled={!currentUser?.canChangePassword}>
        {t('action.changePassword')}
      </CustomButton>
      <EnableTotpModal />
      <DisableTotpModal />
    </Card>
  );
};

export default CurrentUserPasswordTotpCard;
